<template>
  <div>
    <div class="popup-title">{{$lang.messages.help_links.how_we_can_help}}</div>
    <a href="#" class="popup-locked-help" @click.prevent="$emit('goforgot')">
      <span class="popup-locked-help-title">{{$lang.messages.help_links.forgot_passcode}}</span>
      <span class="popup-locked-help-text">{{$lang.messages.help_links.restore_passcode}}</span>
    </a>
    <div class="popup-locked-help">
      <span class="popup-locked-help-title">{{$lang.messages.hints.contact}}</span>
      <span class="popup-locked-help-text">{{$lang.messages.help_links.contact_description}} <strong>info@kidsmode.net</strong></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpLinks',
}
</script>

